import { FC } from 'react'

import styled from 'styled-components'

import { MAX_TABLET_WIDTH } from 'src/Styled/variables'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import {
  ScheduleTrackStepButton,
  StepButtonStatus,
} from 'src/Containers/ui/ScheduleTrackStepButton.js'
import { ModalType } from 'src/Types/ui'
import { useAppSelector } from 'src/Hooks/redux'
import { getScheduledTikTokCampaign } from 'src/Redux/schedule-process/tiktokCampaign/selectors'
import { getIsNewUserForVideosBased } from 'src/Redux/auth-process/userSlice/selectors'

const Container = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  gap: 24px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
  @media screen and (min-width: ${MAX_TABLET_WIDTH}) {
    width: 400px;
  }
`
const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

export const TiktokScheduleSteps: FC = () => {
  const { setSearch } = useCustomSearchParams()
  const scheduledTiktok = useAppSelector(getScheduledTikTokCampaign)
  const isNewUserForVideosBased = useAppSelector(getIsNewUserForVideosBased)
  const { comment, pricingModel } = scheduledTiktok

  const handleGoalClick = (): void => {
    setSearch({ modal: ModalType.CreatorType })
  }

  const handleTaskClick = (): void => {
    setSearch({ modal: ModalType.Comment })
  }

  return (
    <Container>
      <Title>To set up campaign budget complete these steps:</Title>
      {!isNewUserForVideosBased && (
        <ScheduleTrackStepButton
          onClick={handleGoalClick}
          status={
            pricingModel ? StepButtonStatus.completed : StepButtonStatus.active
          }
        >
          select campaign goal
        </ScheduleTrackStepButton>
      )}
      <ScheduleTrackStepButton
        onClick={handleTaskClick}
        status={comment ? StepButtonStatus.completed : StepButtonStatus.active}
      >
        add task for creator
      </ScheduleTrackStepButton>
    </Container>
  )
}
